import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import GloSubscription from "../Components/Subsciptions/Glo";
import AirtelSubscription from "../Components/Subsciptions/Airtel";
import { v4 as uuidv4 } from "uuid";
import Notiflix from "notiflix";

const generateUuid = () => {
  return uuidv4();
};

const BuySpins = () => {
  const navigate = useNavigate();
  let network = localStorage.getItem("network");
  console.log("network: ", network);

  useEffect(() => {
    if (network === "mtn") {
      Notiflix.Loading.circle();
      try {
        const mtnPaymentPage = document.getElementById("mtn-payment-page");
        mtnPaymentPage.click();
        Notiflix.Loading.remove();
      } catch (err) {
        window.location.href = `http://mtn-nigeria-prod.mfilterit.org/sid/234102200007157?trxId=${generateUuid()}`;
        // window.location.href = `https://ng-app.com/NinaJojer/spin4cash-on-demand-landing-en-doi-web?origin_banner=3&trxId=${generateUuid()}&trfsrc=secureD`;
        Notiflix.Loading.remove();
      }
    }
  }, [network]);

  return (
    <div className="buy_spins">
      <Toaster />
      <FaArrowLeftLong onClick={() => navigate(-1)} className="close" />
      <div className="mt-2 title">
        {network === "airtel" ? "" : "Buy More Spins"}
        {network === "glo" && (
          <img src="./images/glo.png" className="mc-buy-more-head-img" alt="" />
        )}
        {network === "airtel" &&
          // <img
          //   src="./images/airtel.png"
          //   className="mc-buy-more-head-img"
          //   alt=""
          // />
          ""}
      </div>

      {network === "glo" && <GloSubscription />}

      {network === "airtel" && <AirtelSubscription />}

      {network === "mtn" && (
        <a
          href={`https://ng-app.com/NinaJojer/spin4cash-on-demand-landing-en-doi-web?origin_banner=3&trxId=${generateUuid()}&trfsrc=secureD`}
          id="mtn-payment-page"
          aria-label="MTN Payment Page"
          className="" // Added btn and btn-primary for styling, and w-100 as requested
        ></a>
      )}
    </div>
  );
};

export default BuySpins;
